"use client";

import { UrlFiltersProvider } from "@/hooks/use-url-filters";
import { MapProvider } from "@/providers/map";
import { SearchPageProvider } from "@/providers/search-page";
import { Pagination } from "@/stores/search/list-store";
import { Bounds } from "@/types/map";
import { Filters } from "@/types/filters";
import type { ListItem, MapItem, MapItemWithCoodId } from "@/types/search";
import { ReactNode } from "react";

interface SearchWithMapProps {
	children: ReactNode;
	slug?: string; // URL slug for SSR-friendly filter initialization
	initialPropertyFilters?: Partial<Filters>;
	initialListData?: ListItem[];
	initialPagination?: Pagination;
	initialMapData?: MapItem[] | MapItemWithCoodId[];
	initialBounds?: Bounds | null;
	initialMapCenter?: { lat: number; lng: number };
	initialMapZoom?: number | null;
	mapId?: string;
	header: ReactNode;
	initialTotalCount?: number | null;
}

export function SearchWithMap({
	children,
	slug,
	initialPropertyFilters,
	initialListData,
	initialPagination,
	initialMapData,
	initialBounds,
	initialMapCenter,
	initialMapZoom,
	mapId,
	header,
	initialTotalCount,
}: SearchWithMapProps) {
	// Extract locations from initialPropertyFilters to pass to SearchPageProvider
	const initialLocations = initialPropertyFilters?.locations || [];

	return (
		<MapProvider>
			<SearchPageProvider
				slug={slug}
				initialListData={initialListData}
				initialPagination={initialPagination}
				initialMapData={initialMapData}
				initialBounds={initialBounds}
				initialMapCenter={initialMapCenter}
				initialMapZoom={initialMapZoom}
				mapId={mapId}
				initialLocations={initialLocations}
				initialTotalCount={initialTotalCount}
			>
				<UrlFiltersProvider initialFilters={initialPropertyFilters}>
					{header}
					{children}
				</UrlFiltersProvider>
			</SearchPageProvider>
		</MapProvider>
	);
}
